import { computed } from 'vue';

import { useFischer } from '@/composables/fischerPlugin';
import type { FischerPlugin } from '@/lib/fischerPlugin';

export const computeWrapperClasses = (themeName: string) => ({
  // NOTE: list all classes plainly here or they might be optimized away
  'component-wrapper--fiwe': themeName === 'fiwe',
  'component-wrapper--fite': themeName === 'fite',
  'component-wrapper--upat': themeName === 'upat',
});

export const computeThemeName = (
  fischer: FischerPlugin | undefined,
  forceTheme: string | null | undefined,
): string => forceTheme || fischer?.theme() || 'fiwe';

export default (forceTheme?: string | null | undefined) => {
  const fischer = useFischer();

  const themeName = computed(() => computeThemeName(fischer, forceTheme));

  const wrapperClasses = computed(() => computeWrapperClasses(themeName.value));

  return { themeName, wrapperClasses };
};
